import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import { prefetchCaseData, useCase, useCaseList, } from '@debbie/cortex/dist/cases/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useUpdatesByRefId } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
import CaseStatus from '../CaseStatus.js';
import Hexagon from '../Icons/Hexagon.js';
const AssociatedCases = (props) => {
    const lang = useSelector((s) => s.lang);
    const casesLoadable = useCaseList({}, 0, 100, {
        associationId: props.associationId,
    });
    const cases = h.hasData(casesLoadable) ? casesLoadable.data : null;
    return (React.createElement(Container, null,
        React.createElement("p", { style: {
                color: THEME.COLOR_ACCENT,
                display: 'inline-block',
                margin: '5px 15px',
                fontSize: '0.85em',
                fontWeight: '900',
            } },
            React.createElement(Hexagon, { style: {
                    margin: '0.15em 3px -0.15em',
                    width: '14px',
                    height: '14px',
                } }),
            ' ',
            lang.associateCases.associateCase),
        cases?.items.map((_case) => (React.createElement(CaseInList, { key: _case.caseId, case: _case, selectedCase: props.singleCase })))));
};
export default AssociatedCases;
const Container = styled.div `
  padding: 5px;
  margin-bottom: ${THEME.GRID_SPACING}px;
  background-color: #e1e1e1;
  border-radius: 3px;
`;
const CaseInList = (props) => {
    prefetchCaseData(props.case.caseId);
    const caseUpdatesLoadable = useUpdatesByRefId(props.case.caseId);
    const caseUpdates = h.hasData(caseUpdatesLoadable)
        ? caseUpdatesLoadable.data
        : null;
    const singleCaseLoadable = useCase(props.case.caseId);
    const singleCase = h.hasData(singleCaseLoadable)
        ? singleCaseLoadable.data
        : null;
    const customerLoadable = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoadable) ? customerLoadable.data : null;
    const contact = customer && props.selectedCase.userOnCustomerId
        ? getContactPerson(customer, props.selectedCase)
        : null;
    const activeUpdates = caseUpdates?.filter((u) => {
        if (!u.continuedAt) {
            return true;
        }
        return moment().isBefore(moment(u.continuedAt));
    });
    return (React.createElement(StyledCaseInList, { onClick: () => {
            // Find a better solution on this. Works both with /cases/${id} and case queue path
            const path = window.location.pathname
                .replace(props.selectedCase.caseId, props.case.caseId)
                .replace(`${props.selectedCase.id}`, `${props.case.id}`);
            c.redirect.redirect(path);
        }, selected: props.selectedCase.caseId === props.case.caseId },
        contact?.details.description && (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, style: {
                position: 'absolute',
                top: '-3px',
                fontSize: '0.7em',
            } }, contact?.details.description)),
        !!activeUpdates?.length && (React.createElement(Badge, { style: {
                margin: '0px 7px 0px 0px',
                verticalAlign: 'middle',
            }, theme: THEME.WARNING }, activeUpdates.length)),
        "#",
        props.case.id,
        " ",
        React.createElement("span", null, props.case.debtorNames),
        ' ',
        React.createElement(CaseStatus, { status: props.case.status, statusTime: props.case.statusTime, endReasonId: props.case.endReasonId })));
};
const StyledCaseInList = styled.div `
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  font-weight: 900;
  padding: 7px 12px;
  margin-right: 5px;
  border-radius: 3px;
  color: #586371;
  font-size: 0.85em;
  text-decoration: none !important;
  background-color: #efefef;
  ${(props) => props.selected
    ? `
    background-color: ${THEME.COLOR_SECONDARY} !important;
    color: ${THEME.COLOR_PRIMARY};
    
    `
    : ''}

  &:hover {
    background-color: ${THEME.COLOR_SECONDARY};
    color: inherit;
  }
`;
//# sourceMappingURL=AssociatedCases.js.map